module.exports = __webpack_public_path__ + "static/Banner.a4aaf99e.png";